import loadable from '@loadable/component';

import { BoxIndicator } from '@classtinginc/design-system';

const ClassroomListPage = loadable(() => import('./ClassroomListPage'), {
  fallback: <BoxIndicator />,
});

export default ClassroomListPage;
